import React from 'react';
import { Form, Col, Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { useTranslation } from 'react-i18next';
const GroupOverviewNotesForm = _ref => {
  let {
    addNote,
    newNote,
    handleNoteChange,
    loading
  } = _ref;
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-start py-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 10
  }, /*#__PURE__*/React.createElement(Form.Control, {
    size: "md",
    type: "text",
    onChange: handleNoteChange,
    value: newNote.content
  })), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: () => addNote(),
    variant: "primary",
    loading: loading,
    disabled: newNote.content.length < 1,
    className: "mx-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons md-18"
  }, "add"), " ", t('add_comments'))));
};
export default GroupOverviewNotesForm;